/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1MoneyMarketStatsEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_MONEY_MARKET_STATS_EVENT_ENTITY_NAME = 'ixc.assets.v1.MoneyMarketStatsEvent';
export const ixcAssetsV1MoneyMarketStatsEventEntity = new schema.Entity<IxcAssetsV1MoneyMarketStatsEvent>(IXC_ASSETS_V1_MONEY_MARKET_STATS_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1MoneyMarketStatsEvent) => `${entity.metadata?.eventId}` });

